import { render, staticRenderFns } from "./origianlForm.vue?vue&type=template&id=029042dc&scoped=true&"
import script from "./origianlForm.vue?vue&type=script&lang=js&"
export * from "./origianlForm.vue?vue&type=script&lang=js&"
import style0 from "./origianlForm.vue?vue&type=style&index=0&id=029042dc&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029042dc",
  null
  
)

export default component.exports